import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../../../utils/Encryption";

export function useApplicationId() {
    const { id,id2 } = useParams();
    return useMemo(() => (id ? decryptAESID(id.toString(), false) : null), [id]);
}